// @flow
import Enum from 'common/enums/Enum';

export const ExportStatus = new Enum({
    QUEUED: 'QUEUED',
    DONE: 'DONE'
});

export type ExportStatusType = $Keys<typeof ExportStatus>;
